export const all = promises => {
  return Promise.all(
    Object.entries(promises).map(([name, promise]) =>
      promise.then(result => ({ name, result }))
    )
  ).then(results =>
    results.reduce((prev, curr) => {
      prev[curr.name] = curr.result;
      return prev;
    }, {})
  );
};
